// src/loadRoomAreas.js
import yaml from 'js-yaml';

/**
 * Loads the room→area mapping from public/roomAreas.yml
 * (in production this lives under build/roomAreas.yml).
 */
export async function loadRoomAreas() {
  const base = window.IepAppConfig?.buildUrl || process.env.PUBLIC_URL || '';
  const url  = `${base}roomAreas.yml`;    // ensure .yml, not .yaml

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Could not load roomAreas.yml (${res.status} ${res.statusText})`);
  }
  const text = await res.text();
  return yaml.load(text);
}